import React from "react";
import "./About.css";
import Members from "./Members.js";
import Abtimg1 from "../../../assests/About-text-1.jpg";
import AbtImg2 from "../../../assests/Abt-img-2.jpg";
import { ImageGroup, Image } from "react-fullscreen-image";
import PaperClip1 from "../../Images/PaperClip1.png";
import PaperClip2 from "../../Images/PaperClip2.png";
import PaperClip3 from "../../Images/PaperClip3.png";
import PaperClip4 from "../../Images/PaperClip4.png";
import PaperClip5 from "../../Images/PaperClip5.png";
import PaperClip6 from "../../Images/PaperClip6.png";
import PaperClip7 from "../../Images/PaperClip7.png";
import AboutUs1 from "../../../assests/AboutUsHero1.jpg";

function About() {
  const images = [
    PaperClip1,
    PaperClip2,
    PaperClip3,
    PaperClip4,
    PaperClip5,
    PaperClip6,
    PaperClip7,
  ];
  return (
    <>
      <div className="HeroImage">
        <img src={AboutUs1} alt="" />
      </div>
      <div className="newIsbcIntro">
        <center>
          <h1>Introduction to ISBC</h1>
        </center>
        <div className="innerIntroAbout">
          <div className="Img-abt-1">
            <img src={Abtimg1} alt="" />
          </div>
          <div className="Abt-text-1">
            <p>
              {" "}
              ISBC, Indian Schools Board for Cricket, has entered into grooming
              of school cricketers in India, the Indian education system which
              is one of the largest in the world with more than 1.5 million
              schools and 250 million children. ISBC, intends to reach out to
              the nook and corner of India for creating level playing field for
              the Rural cricket talent; in this endeavor we started CAT,Cricket
              Association of Telangana in 2011 for the rural cricketers of
              Telangana region. In the last twelve years CAT could see some
              extraordinary cricketing talent among the rural kids, we could
              identify some of the reasons, ways and means to overcome the
              challenges in developing rural cricket PAN India, and ISBC is the
              answer. India needs an organized structure in grooming school
              cricketers which are numbered at about 25 crores. ISBC’s vision is
              to give an opportunity to all those children who believe they can
              play cricket but are less fortunate. ISBC will be focusing on
              building infrastructure, in conducting regular cricket camps,
              organizing cricket tournaments of different age groups and in the
              process we are structuring the state bodies who will be
              responsible in this talent hunt and nurture project.. ISBC is in
              consultation with major school managements for their partnership
              in grooming school cricket talent, and we are happy for some of
              them giving their nod. We are inspired by Jay Shah, Hon’ble
              Secretary BCCI, Mr. Shah said during his taking over as the
              president of ACC, Asia Cricket Council, few years back that he
              wants to reach out to the nook and corner of Asia for the
              development of cricket.
            </p>
          </div>
        </div>
      </div>
      {/* ----------------------------------- */}

      <div className="newIsbcIntro">
        <div className="innerIntroAbout-2">
          <div className="Abt-text-1">
            <p>
              Yes, ISBC will be organizing an annual event called ISTL, Indian
              Schools Talent League, reaching out for school cricket talent to
              every corner of India, the total structure, schedule and
              partnerships will be announced once the state bodies are formed by
              the end of December 2023. Under the ISTL there will be educational
              scholarships and expert cricket training at ICC level academies in
              India and Abroad. We did TSPL, Telangana Schools Premier League
              few years back as a Pilot project, which was a huge success with
              total number of 5120 school cricketers participated in the
              tournament from 31 districts of Telangana State, we did 550
              matches in the TSPL. ISBC will start the cricketing activities
              from the month of July/August for the 2023/24 Season. ISBC is
              fortunate to have Indian cricketing legend, former captain and
              chief selector, Padma Shri Dilip Vengsarkar as our chief advisor,
              he was the chairman for BCCI’s talent research wing for nearly two
              decades, his vast experience will be a blessing in grooming the
              Indian school cricket talent. ICC, International Cricket Council
              has 108 countries as its members, apart from 12 Test playing
              countries who are the full members and the rest are the affiliate
              members, most of the new cricket countries seem to be slow in
              their take off, in the larger interest of developing cricket among
              the new countries in the world, ISBC is taking the lead in forming
              a group for grooming school cricketers world-wide, In this
              endeavor we are happy to form a group of 19 countries which will
              be announced very shortly, Under this group we are planning to
              conduct “SCHOOLS WORLD CUP”. The ISBC has a very strong team, its
              office bearers are a mix of ex-cricketers and very successful
              entrepreneurs who are determined to create a strong platform for
              rural cricket talent with a vision to see… HAR GHAR KHILADI.
            </p>
          </div>
          <div className="Img-abt-1">
            <img src={AbtImg2} alt="" />
          </div>
        </div>
      </div>

      <div className="AboutusContainer">
        <hr />
        {/*__________________Members______________________________*/}

        <Members />

        {/*__________________News-Articles______________________________*/}
      </div>
      <div className="newsArticles">
        <center>
          <h1>ISBC In Media </h1>
        </center>
        <ImageGroup>
          <ul className="images">
            {images.map((i) => (
              <li key={i}>
                <Image
                  src={i}
                  alt="Isbc"
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    height: "100%",
                    width: "100%",
                    objectFit: "contain",
                    zIndex: 0,
                  }}
                />
              </li>
            ))}
          </ul>
        </ImageGroup>
      </div>
    </>
  );
}

export default About;
